import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PendapatanProdukPromoContent from "./PendapatanProdukPromoContent";

const SalesMembershipsPromoPage = () => (
  <PendapatanProdukPromoContent
    type="membership"
    title={translate("analyticsPage.membership.report_pendapatan_produk_promo")}
    backTo={PATHS.ANALYTICS}
  />
);

export default SalesMembershipsPromoPage;
